<template>
  <div style="height:100%">
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
  </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';

export default {
  name: 'SalesIndex',
  components: {
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState('webApp', ['config', 'storageLocation', 'appSchema']),
  },
  async created() {
    this.loading = true;
    const appId = localStorage.getItem('appId');
    await this.getAppSchema(appId);
    if (this.appSchema && this.appSchema.modules && this.appSchema.assetId) {
      this.setAssetId(this.appSchema.assetId);
      this.setModules(this.appSchema.modules);
    }
    this.loading = false;
  },
  methods: {
    ...mapMutations('webApp', ['setConfig', 'resetConfig']),
    ...mapMutations('fileManager', [
      'setModules',
      'setAssetId',
    ]),
    ...mapActions('webApp', ['getAppSchema']),
  },
};
</script>
